import styled, { css } from 'styled-components';

import {
  scale005,
  scale010,
  scale020,
  scale050,
  scale100,
  xdlColorProgressBadgeBackground01,
  xdlColorProgressBadgeBackground02,
  xdlColorProgressBadgeBackground03,
  xdlColorProgressBadgeBackground04,
  xdlColorTextOnDark,
  xdlColorTextOnLight,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import type { ProgressBadgeFractionalVariants } from './progress-badge-fractional.types';

type ProgressBadgeFractionalTProps = {
  $progress: number;
  $variant?: ProgressBadgeFractionalVariants;
};

export const variants = {
  default: (props: ProgressBadgeFractionalTProps) => css`
    background-color: ${() => {
      if (props.$progress <= 39) return xdlColorProgressBadgeBackground01;
      if (props.$progress <= 79) return xdlColorProgressBadgeBackground02;
      if (props.$progress <= 99) return xdlColorProgressBadgeBackground03;
      return xdlColorProgressBadgeBackground04;
    }};
  `,
  singleColor: () => css`
    background-color: ${xdlColorProgressBadgeBackground04};
  `,
};

// *** Components ***
export const ProgressBadgeFractional = styled.span<ProgressBadgeFractionalTProps>`
  border-color: ${xdlColorTextOnDark};
  border-radius: ${scale050};
  border-style: solid;
  border-width: ${scale010};
  display: inline-flex;
  flex-shrink: 0;
  height: ${scale100};
  padding-inline-end: ${scale020};
  padding-inline-start: ${scale020};
  transition: background-image 0.3s ease;

  ${(props) => css`
    ${props.$variant && variants[props.$variant](props)}
  `};
`;

export const Text = styled(BodyCopy)`
  color: ${xdlColorTextOnLight};
  inset-block-start: -${scale005};
  position: relative;
`;
